import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Icon as BlueIcon, Icon } from '@blueprintjs/core';

import { getPicturesByEquipment } from '@services/queries/pictures/getPicturesByEquipment/getPicturesByEquipment';

// import SerachIcon from '@assets/svg/table-search.svg';
import { useQuery } from 'react-query';
import { useHookstate } from '@hookstate/core';
import { ListInformationError } from '@pages/Asset/components/Legacy/ListInformation/error/ListInformation.error';
import { Text } from '@components/index';
import { useSelector } from 'react-redux';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { Portal } from '@mantine/core';
// import { SearchFigma } from '@components/SearchBars';
import { ResourcesPicturesLoading } from './loading/ResourcesPicturesOverview.loading';
import { Menu } from './Components/Menu/Menu';

import {
  Overlay,
  Container,
  LeftContainer,
  RowDiv,
  // Title,
  AddButton,
  // AddText,
  RightContainer,
  Buttons,
  BigPicture,
  // Container1,
  // SelectedMark,
  // Divider,
  DividerLine,
  // Text,
  BigPictureImg,
  // InputContainer,
  // InputSearch,
  // ProfileImg,
  // SearchIconContainer,
  // Tags,
  // TagsDiv,
  // WrapperRow,
  ButtonsContainer,
  RightContainerTitleGroup,
  PicturesOverviewSearch,
} from './PicturesOverview.styles';
import { ListPictures } from './ListPictures';

interface IModal {
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAdd: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedPicture: React.Dispatch<React.SetStateAction<string>>;
  selectedPicture: string;
}

const PicturesOverview = ({
  setShow,
  setShowAdd,
  selectedPicture,
  setSelectedPicture,
}: IModal) => {
  const params = useParams<{ equipmentId: string }>();

  const searchLocal = useHookstate('');

  const { isLoading, isError, data } = useQuery(
    ['equipments', params.equipmentId, 'pictures'],
    () => getPicturesByEquipment({ id: params.equipmentId }),
  );

  const { isDesktop, isMobile } = useSelector(checkDevice());
  const lowercaseSearch = searchLocal.get().toLowerCase();
  const dataFiltered = useMemo(() => {
    if (!data) return [];
    return data.filter(item =>
      item.name.toLowerCase().includes(lowercaseSearch),
    );
  }, [data, lowercaseSearch]);

  if (isLoading) {
    return <ResourcesPicturesLoading />;
  }

  if (isError || !data) {
    return <ListInformationError />;
  }

  const picture = data.find(item => item.id === selectedPicture);

  return (
    <Portal>
      <Overlay>
        <Container>
          <RowDiv>
            {isDesktop && (
              <LeftContainer>
                <RowDiv className="new-icon title">
                  <Text text="h600" textColor="n900">
                    Photos
                  </Text>

                  <AddButton
                    text="b200"
                    textColor="b401"
                    onClick={() => setShowAdd(true)}
                  >
                    <Icon icon="plus" />
                    <Text inherit>ADD</Text>
                  </AddButton>
                </RowDiv>

                <PicturesOverviewSearch
                  placeholder="Find a picture"
                  onChange={searchLocal.set}
                />
                {/* <InputContainer>
                  <SearchIconContainer>
                    <img src={SerachIcon} alt="search" />
                  </SearchIconContainer>
                  <InputSearch
                    value={searchLocal.get()}
                    onChange={e => searchLocal.set(e.target.value)}
                  />
                </InputContainer> */}

                <ListPictures
                  data={dataFiltered}
                  setSelectedPicture={setSelectedPicture}
                  selectedPicture={selectedPicture}
                />
              </LeftContainer>
            )}
            <RightContainer className="new-icon">
              <RightContainerTitleGroup>
                {isMobile && (
                  <RowDiv className="title">
                    <Text text="h500" textColor="n900">
                      Photos
                    </Text>
                    <Buttons onClick={() => setShow(false)}>
                      <BlueIcon icon="cross" color="#8F95B2" />
                    </Buttons>
                  </RowDiv>
                )}
                <RowDiv className="title">
                  <Text text="p300" textColor="n900">
                    {picture?.name}
                  </Text>

                  <ButtonsContainer>
                    {selectedPicture && (
                      <Menu
                        selectedPicture={selectedPicture}
                        picture={picture}
                        data={data}
                        setSelectedPicture={setSelectedPicture}
                        setShow={setShow}
                      />
                    )}
                    {isDesktop && (
                      <Buttons
                        className="new-icon"
                        onClick={() => setShow(false)}
                      >
                        <BlueIcon icon="cross" color="#8F95B2" />
                      </Buttons>
                    )}
                  </ButtonsContainer>
                </RowDiv>
              </RightContainerTitleGroup>
              {isDesktop && <DividerLine />}
              {/* <TagsDiv>
              <WrapperRow>
                <Tags>TAG NAME</Tags>
                <Tags>TAG NAME</Tags>
              </WrapperRow>

              <WrapperRow>
                <Text>Added by:</Text>
                <ProfileImg src={AvatarPlaceholder} alt="ProfileImg" />
                <Text className="personName">PROFILE NAME</Text>
              </WrapperRow>
            </TagsDiv> */}

              {selectedPicture ? (
                <BigPicture className="full-bleed">
                  <BigPictureImg
                    src={
                      picture?.type === 'uri'
                        ? picture?.uri
                        : picture?.file?.uri
                    }
                    alt="AssetImg"
                  />
                </BigPicture>
              ) : (
                <div />
              )}

              {isMobile && (
                <ListPictures
                  data={dataFiltered}
                  setSelectedPicture={setSelectedPicture}
                  selectedPicture={selectedPicture}
                />
              )}
            </RightContainer>
          </RowDiv>
        </Container>
      </Overlay>
    </Portal>
  );
};

export { PicturesOverview };
